module.exports = __webpack_public_path__ + "static/img/greedy_bg.22b402e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/greedy_bg.png
// module id = /2Vm
// module chunks = 0